import { useTranslation } from 'react-i18next';

export default function useNameReference(useShort) {
  let { t } = useTranslation();
  if (t('locale') !== 'fr') return { nameReference: useShort ? 'labelEnglishShort' : 'labelEnglish' };

  return { nameReference: useShort ? 'labelFrenchShort' : 'labelFrench' };
}
